import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { TokenResponseWSO2 } from '../../models/tokenResponseWSO2';
import { SecureLoginDataModel } from './../../../shared/models/crypto/crypto.models';
import { CryptoService } from './../../../shared/services/crypto/crypto.service';

@Injectable({
  providedIn: 'root',
})
export class GenerateTokenService {
  private tokenSubject$ = new BehaviorSubject<string | null>(null);
  private token$: any = this.tokenSubject$.pipe(
    filter((token) => token !== null),
    take(1),
  );

  private readonly http: HttpClient;
  constructor(
    private handler: HttpBackend,
    private cryptoService: CryptoService,
  ) {
    this.http = new HttpClient(this.handler);
    const access_token = sessionStorage.getItem('access_token');
    if (access_token) {
      this.token$.next(access_token);
    } else {
      this.generateToken().subscribe();
    }
  }

  getToken() {
    return this.token$.pipe(
      filter((token) => token !== null),
      take(1),
    );
  }

  generateToken(): Observable<string> {
    return this.cryptoService
      .getSecureLoginApi({
        application: 'mortgages-new',
        channel: 'web',
      })
      .pipe(
        switchMap((data: SecureLoginDataModel) => {
          let headers = new HttpHeaders();
          headers = headers
            .set('KeyToken2', data.keyToken2)
            .set('Content-type', 'application/json');
          return this.http
            .post<TokenResponseWSO2>(
              `${environment.apiBase}/auth/core/${environment.api_version.authCore}/token`,
              { encryptedToken: data.body.encryptedTokenL2 },
              { headers },
            )
            .pipe(
              tap((data) => {
                sessionStorage.setItem('access_token', data.access_token);
                this.token$.next(data.access_token);
              }),
              map((data: TokenResponseWSO2) => data.access_token),
            );
        }),
      );
  }
}
